import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ButtonGroup, Button } from '@appcues/sonar';
import { Heading, Modal, ModalHeader } from 'ext/components/ui';
import { AccountsList } from 'ext/components/AccountsList';
import { change } from 'entities/auth';
import { Body } from './styled';

export function AccountsModal({
  accounts,
  onChange,
  onClose,
  selected: initial,
  visible,
}) {
  // Determines if an account switch has been requested
  const [isPending, setIsPending] = useState(false);

  // Immediately set newly selected account for instant UI feedback
  const [selected, setSelected] = useState(initial);

  // Handle account selection
  const handleSelect = useCallback(
    id => {
      if (!isPending) {
        setIsPending(true);
        setSelected(id);
        onChange(id);
      }
    },
    [onChange, isPending]
  );

  return (
    <Modal onClose={onClose} visible={visible} theme="light">
      <ModalHeader>
        <Heading>Your Accounts</Heading>
        <ModalHeader.Close onClose={onClose} />
      </ModalHeader>

      <Body>
        <AccountsList
          accounts={accounts}
          selected={selected}
          isPending={isPending}
          onSelect={handleSelect}
        />

        <ButtonGroup>
          <Button variant="tertiary" onClick={onClose} type="button">
            Cancel
          </Button>
        </ButtonGroup>
      </Body>
    </Modal>
  );
}

AccountsModal.propTypes = {
  accounts: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  selected: PropTypes.string,
  visible: PropTypes.bool,
};

const mapDispatchToProps = {
  onChange: change,
};

export default connect(null, mapDispatchToProps)(AccountsModal);
